import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ACADEMY_LOGO } from "../data/assets";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get("e") || "";
  const token = params.get("t") || "";
  const [status, setStatus] = useState("working"); // working | done | error

  useEffect(() => {
    if (!email || !token) { setStatus("error"); return; }
    axios.post(`${API}/unsubscribe`, { email, token })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [email, token]);

  return (
    <div className="min-h-screen bg-[#111111] text-white flex items-center justify-center px-6 grain">
      <div className="absolute inset-0 red-glow pointer-events-none" />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="relative z-10 w-full max-w-md bg-[#141414] border border-white/10 rounded-2xl p-8 text-center" data-testid="unsubscribe-card">
        <img src={ACADEMY_LOGO} alt="The Next O Technical Academy" className="w-40 h-auto object-contain mx-auto mb-5" />
        {status === "working" && (
          <div data-testid="unsub-working" className="py-6 flex flex-col items-center gap-3 text-white/60">
            <Loader2 size={28} className="animate-spin text-[#C41E24]" /> Updating your preferences…
          </div>
        )}
        {status === "done" && (
          <div data-testid="unsub-done">
            <CheckCircle2 size={44} className="text-[#22C55E] mx-auto mb-4" />
            <h1 className="font-headings text-3xl uppercase tracking-wide mb-2">You're unsubscribed</h1>
            <p className="text-white/55 text-sm">{email ? <><b className="text-white/80">{email}</b> won't</> : "You won't"} receive automated Next O Soccer emails anymore. You'll still get essential account emails (like password resets).</p>
            <button data-testid="unsub-home-btn" onClick={() => navigate("/")}
              className="mt-6 w-full bg-[#C41E24] hover:bg-[#A0161D] text-white font-subheadings font-bold uppercase tracking-wider py-3 rounded-sm transition-colors">
              Back to Next O Soccer
            </button>
          </div>
        )}
        {status === "error" && (
          <div data-testid="unsub-error">
            <AlertCircle size={44} className="text-[#C41E24] mx-auto mb-4" />
            <h1 className="font-headings text-3xl uppercase tracking-wide mb-2">Link not valid</h1>
            <p className="text-white/55 text-sm">This unsubscribe link is invalid or has expired. Please use the link from your most recent email, or contact us to be removed.</p>
            <button onClick={() => navigate("/")}
              className="mt-6 w-full border border-white/20 hover:border-white/40 text-white/80 hover:text-white font-subheadings font-bold uppercase tracking-wider py-3 rounded-sm transition-colors">
              Back to Home
            </button>
          </div>
        )}
      </motion.div>
    </div>
  );
}
